let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7bQxl")).then(() => parcelRequire('f4gvG'));